import { getS3PdfWithLocale } from '../lib/helpers'
import { getS3PdfWithLocaleIDS } from '../lib/helpers'
import { getS3Mp4WithLocaleIDS } from '../lib/helpers'

// Error codes

export const UNAUTHORIZED = 'unauthorized'
export const NOT_FOUND = 'notFound'
export const FORBIDDEN = 'forbidden'
export const CANCELED = 'canceled'
export const NETWORK_ERROR = 'networkError'
export const CONFLICT = 'conflict'
export const UNAVAILABLE = 'UNAVAILABLE'

export const systemRequirementsUrl = getS3PdfWithLocale('IDS_MDARS_System_Requirements')

export const mdarsIIRequirementsUrl = getS3PdfWithLocale('MDARSII_Download_Instructions')

export const mdarsIIManualUrl = getS3PdfWithLocale('MDARS_II_User_Guide')

export const densoManualUrl = getS3PdfWithLocale('Denso_Scan_Tool_Driver_Installation')

export const hardwareRequirementsUrl = getS3PdfWithLocale('MDSFA_MMP_Hardware_Process')

export const mdarsUserManualUrl = getS3PdfWithLocale('MDARS_User_Guide')

export const mdarsDownloadInstructionsUrl = getS3PdfWithLocale('MDARS_Download_Instructions')

export const mdarsProgrammingManualUrl = getS3PdfWithLocale('MDARS_lost_key_programming')

export const trainingCourseListUrl = getS3PdfWithLocale('Course_Listing')

export const idsUserManualUrl = getS3PdfWithLocale('IDS_Users_Manual')

export const softwareExplainedUrl = getS3PdfWithLocale('Mazda_Software_Explained_Before_Purchase')

export const idsCalFilesInstructionsUrl = getS3PdfWithLocale('IDS_Calibration_File_Tool_Installation_Instructions_Aftermarket')

export const idsMissingCalFilesInstructionsUrl = getS3PdfWithLocaleIDS('Cal File Download from Web')

export const idsMissingCalFilesInstructionsUrlMp4 = getS3Mp4WithLocaleIDS('IDS_CAL_FILE_DOWNLOAD')



// WEBPACK FOOTER //
// ./constants/index.js